(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/views/AppView',["jquery", "backbone", "pricelist/views/InfoTabsView", "pricelist/views/SideBarView", "pricelist/views/PriceListView", "pricelist/views/FormatMapView2"], function($, Backbone, InfoTabsView, SideBarView, PriceListView, FormatMapView2) {
    var View;
    return View = (function(superClass) {
      extend(View, superClass);

      function View() {
        this.priceListChange = bind(this.priceListChange, this);
        return View.__super__.constructor.apply(this, arguments);
      }

      View.prototype.el = ".container";

      View.prototype.initialize = function() {
        this.priceList = this.options.priceList;
        this.priceListView = new PriceListView({
          model: this.priceList
        });
        this.infoTabsView = new InfoTabsView({
          model: this.priceList
        });
        return this.formatMapView = new FormatMapView2({
          model: this.priceList
        });
      };

      View.prototype.render = function() {
        var $container;
        this.$("#select-priceList").val(this.priceList.get("id"));
        this.infoTabsView.render();
        $container = this.$("section#container");
        $container.empty();
        $container.append(this.priceListView.el);
        return this;
      };

      View.prototype.events = {
        "change #select-priceList": "priceListChange",
        "click .node-container": "onSelectedFormat"
      };

      View.prototype.priceListChange = function(event) {
        this.priceListView.model.set({
          id: $(event.currentTarget).val()
        });
        app.router.navigate((this.priceListView.model.get("id")) + "/" + this.priceListView.model.get("layout"));
        this.infoTabsView.model.set({
          id: $(event.currentTarget).val()
        });
        return this.infoTabsView.render();
      };

      View.prototype.onSelectedFormat = function(event) {
        var currentId;
        currentId = event.currentTarget.getAttribute("data-id");
        this.priceList.set({
          selectedPriceId: currentId
        });
        $(".node-container").removeClass("highlight-selected-price");
        return $(event.currentTarget).addClass("highlight-selected-price");
      };

      return View;

    })(Backbone.View);
  });

}).call(this);

//# sourceMappingURL=AppView.js.map
;
